
import { Inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, delay, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { IShippingModel } from "../models/shipping/shipping.model";
import { ShippingMapping } from "../mappings/shipping.mapping";
import { ShippingPutRequestDtoModel } from "../models/shipping/dto/shipping-put-dto.model";
import { IShippingDtoModel } from "../models/shipping/dto/shipping.dto.model";
import { EnvironmentService } from "./environment.service";
import { ApplicationContextService } from "./application-context.service";
import { IShippingProvider } from "../models/shipping/shipping-provider.model";
import { IShippingMethod } from "../models/shipping/shipping-method.model";
import { CoreService } from "./customer-core.service";
import { IUserDtoModel } from "../models/user/user-dto.model";
import { UtilitiesService } from "./utilities.service";


@Injectable({
    providedIn: 'root'
})
export class UsersService {

    constructor(private readonly httpClient: HttpClient,
        public envService: EnvironmentService,
        private applicationContext: ApplicationContextService,
        private customerService: CoreService,
        private utilities: UtilitiesService) {
    }


    public getAccountManagers(activeBranchOnly?: boolean): Observable<string[]> {

        if (this.applicationContext.isPublic() === true) {
            return of([]);
        }

        return this.httpClient.get<IUserDtoModel[]>(`${this.envService.settings.apiUrl}/Options/accountmanagerusernames`)
            .pipe(
                map(managers => {

                    if(activeBranchOnly && this.applicationContext.isApplicationEmbedded()){

                        let activeBranchCode: string = this.applicationContext.getBranchCodeFromUrl();
                        let accountManagersOfOtherBranches: string[] = [];

                        for (let index = 0; index < this.envService.settings.branches.length; index++) {
                            if(this.envService.settings.branches[index].code != activeBranchCode)  {
                                accountManagersOfOtherBranches.push(this.envService.settings.branches[index].defaultCustomerManagerUsername)
                            }                          
                        } 
                        managers = managers.filter((manager) => accountManagersOfOtherBranches.includes(manager.username) == false);
                    }

                    managers = this.utilities.sortArrayObjectsAlphabetically(managers, 'username');

                    return managers.map(manager => {
                        return manager.username as string
                    })
                })
            );
    }

    public getDefaultAccountManagerForBranch(branchCode?: string): string {

        if (!branchCode) {
            branchCode = this.applicationContext.getBranchCodeFromUrl();
        }

        for (let i = 0; i < this.envService.settings.branches.length; i++) {
            if (branchCode == this.envService.settings.branches[i].code) {
                return this.envService.settings.branches[i].defaultCustomerManagerUsername;
            }
        }

        return 'sales.uk@sngbarratt.com';


    }

    public getDefaultAccountManagersForAllBranches(): string[] {

        let defaultManagers = [];

        for (let i = 0; i < this.envService.settings.branches.length; i++) {
            defaultManagers.push(this.envService.settings.branches[i].defaultCustomerManagerUsername);
        }

        return defaultManagers;

    }

}